export default __webpack_public_path__ + "static/media/Greenhouse_01.a0934314.webp";